module.exports = __webpack_public_path__ + "public/images/account/defaultPhoto.bbca596dc676869086d1c4a444894df6.svg";